import * as React from 'react';
import { StoreProvider } from 'easy-peasy';
import { ThemeProvider } from 'styled-components';
import { store } from './store';
import { Player } from './components/Player';
import { ChromecastProvider } from './components/ChromecastProvider';
import { VHSProvider } from './components/VHSProvider';
import { VideoPlayerProps } from './typings';
import { ConvivaProvider } from './components/ConvivaProvider';
import theme from './utils/theme';

export * from './utils/store-actions-map';

export const WebVideoPlayer: React.FunctionComponent<VideoPlayerProps> = React.memo((props: VideoPlayerProps) => {
  return (
    <StoreProvider store={store}>
      <ConvivaProvider>
        <VHSProvider>
          <ChromecastProvider>
            <ThemeProvider theme={theme}>
              <Player {...props} />
            </ThemeProvider>
          </ChromecastProvider>
        </VHSProvider>
      </ConvivaProvider>
    </StoreProvider>
  );
});
